import { SortOptions } from '~src/ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';

export const resourceGovernanceSettingSortOptions: OptionsDictionary = {
  'siteName': SortOptions.siteName,
};
